// extracted by mini-css-extract-plugin
export var errorsContainer = "_ux-1";
export var link = "_ux-0";